import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import success from '@/assets/lotties/success.json'
import { Feedback } from '@/components/Feedback/Feedback'
import { WeScreen } from '@/components/WeScreen/WeScreen'

export const KYCVerificationSuccess = () => {
  const { t } = useTranslation()

  return (
    <WeScreen useHeader={false}>
      <Feedback
        lottie={success}
        lottieLoop={false}
        title={t('kyc.success.title')}
        message={t('kyc.success.message')}
        primaryButtontext={t('kyc.success.launchButton')}
      />
      <p className="text-neutralColor80 text-sm font-medium text-center ">
        {t('kyc.success.privacyNote')} &nbsp;
        <Link
          className="text-dynamicBlue"
          target="_blank"
          to={
            'https://help.withpersona.com/articles/7fhhIrBgdgKWTPyWPvGfBH/edit-the-list-of-allowed-domains-to-redirect-to'
          }
        >
          {t('kyc.success.learnMore')}
        </Link>
      </p>
    </WeScreen>
  )
}
